import { useEffect, useState } from "react";
import { TextShimmer } from "../../../../Components/ui/text-shimmer";
import { TextLoop } from "../../../../Components/ui/text-loop";

export default function ChatBotTextShimmer() {
  const ScanningPlaybook = [
    "In the huddle...",
    "Scanning the playbook...",
    "Drawing up the perfect play...",
    "Crunching the numbers...",
    "Watching film on your opponent...",
    "Reading the defense...",
    "Breaking down the tape...",
    "Calling an audible...",
    "Running some plays...",
    "Analyzing formations...",
    "Checking matchups...",
    "Reading coverage...",
    "Loading game script...",
    "Dialing up a blitz...",
  ];

  const [shuffledPlaybook, setShuffledPlaybook] = useState<string[]>([]);

  // Function to shuffle array
  const shuffleArray = (array: string[]) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  useEffect(() => {
    setShuffledPlaybook(shuffleArray(ScanningPlaybook));
  }, []);

  return (
    <>
      <TextLoop interval={3}>
        {shuffledPlaybook.map((text, index) => (
          <TextShimmer
            key={`${text}-${index}`}
            duration={3}
            className="text-[12px] font-medium [--base-color:theme(colors.blue.600)] [--base-gradient-color:theme(colors.blue.200)] dark:[--base-color:theme(colors.blue.700)] dark:[--base-gradient-color:theme(colors.blue.400)]"
          >
            {text}
          </TextShimmer>
        ))}
      </TextLoop>
    </>
  );
}
